import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from './hooks/use-appearance';
import GoogleAnalytics from './components/GoogleAnalytics';
import CookieBanner from './components/CookieBanner';
import { useState } from 'react';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

function AppWithConsent({ App, props }: { App: any; props: any }) {
    const [hasAnalyticsConsent, setHasAnalyticsConsent] = useState(false);
    const analytics = (props.initialPage.props as any).analytics;
    const user = (props.initialPage.props as any).auth?.user;

    return (
        <>
            <CookieBanner
                onAnalyticsConsent={setHasAnalyticsConsent}
                userId={user?.id ?? null}
            />
            <GoogleAnalytics
                trackingId={analytics?.google_analytics_id}
                environment={analytics?.environment}
                hasConsent={hasAnalyticsConsent}
            />
            <App {...props} />
        </>
    );
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<AppWithConsent App={App} props={props} />);
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();
